<template>
  <section v-if="comList.length > 1">
    <el-select
      class="comSelect"
      v-model="comId"
      @change="changeCom"
      placeholder="厂区切换"
    >
      <el-option
        v-for="item in comList"
        :key="item.com_id"
        :label="item.com_name"
        :value="item.com_id"
      >
      </el-option>
    </el-select>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      comList: [],
      comId: ""
    };
  },
  created() {
    this.$common
      .http({
        method: "get",
        url: "/api/permission/list_com"
      })
      .then(res => {
        this.comList = res.data.data || [];
        this.$nextTick(() => {
          this.setBaseList(this.comList.filter((e) => e.is_main_com === 0));
        });
        this.comList.forEach(element => {
          if (Number(element.com_is_current) == 1) {
            this.comId = element.com_id;
            console.log("baseInfo", element);
            this.setBaseInfo(element);
          }
        });
      });
  },
  computed: {
    ...mapGetters(["privilegeConfig"])
  },
  methods: {
    ...mapActions(["fetchPrivilege", "setBaseInfo", "setBaseList"]),
    changeCom() {
      this.$common
        .http({
          url: "/api/authorize/switch_com",
          data: {
            com_id: this.comId
          }
        })
        .then(async () => {
          await this.fetchPrivilege();
          console.log("当前用户权限Privilege", this.privilegeConfig);
          this.$router.push("/rhqy/lyout");
          // 同浏览器的不同tab同时刷新
          window.localStorage.setItem("changeFactory", new Date().getTime());
          location.reload(true);
          // let href = location.origin + location.pathname + "#/rhqy/lyout";
          // location.replace(href);
        });
    }
  }
};
</script>
<style scoped lang="less">
.comSelect {
  margin-left: 10px;
  width: 140px;
}
</style>
